export const removeMapButtons = () => {
    removeZoomButtons();
    removeFullscreenButton();
    removeRotationButton();
};

export const removeZoomButtons = () => {
    const zoomControl = document.getElementsByClassName(
        'leaflet-control-zoom leaflet-bar leaflet-control',
    ) as HTMLCollectionOf<HTMLElement>;
    const zoomOutButton = document.getElementsByClassName('leaflet-control-zoom-out') as HTMLCollectionOf<HTMLElement>;
    const zoomInButton = document.getElementsByClassName('leaflet-control-zoom-in') as HTMLCollectionOf<HTMLElement>;

    if (zoomOutButton[0]) zoomOutButton[0].style.display = 'none';
    if (zoomInButton[0]) zoomInButton[0].style.display = 'none';
    if (zoomControl[0]) zoomControl[0].style.display = 'none';
};
export const restoreZoomButtons = () => {
    const zoomControl = document.getElementsByClassName(
        'leaflet-control-zoom leaflet-bar leaflet-control',
    ) as HTMLCollectionOf<HTMLElement>;
    const zoomOutButton = document.getElementsByClassName('leaflet-control-zoom-out') as HTMLCollectionOf<HTMLElement>;
    const zoomInButton = document.getElementsByClassName('leaflet-control-zoom-in') as HTMLCollectionOf<HTMLElement>;

    if (zoomOutButton[0]) zoomOutButton[0].style.display = 'block';
    if (zoomInButton[0]) zoomInButton[0].style.display = 'block';
    if (zoomControl[0]) zoomControl[0].style.display = 'block';
};
export const removeFullscreenButton = () => {
    const fullScreenButton = document.getElementsByClassName('leaflet-control-fullscreen') as HTMLCollectionOf<HTMLElement>;
    if (fullScreenButton[0]) fullScreenButton[0].style.display = 'none';
};

export const removeRotationButton = () => {
    const rotationButton = document.getElementsByClassName('leaflet-control-rotate') as HTMLCollectionOf<HTMLElement>;
    if (rotationButton[0]) rotationButton[0].style.display = 'none';
};

export const removeEditTools = () => {
    const editToolBar = document.getElementsByClassName('leaflet-draw-toolbar') as HTMLCollectionOf<HTMLElement>;
    if (editToolBar[0]) editToolBar[0].style.display = 'none';
};

export const removeDeleteButton = () => {
    const deleteButton = document.getElementsByClassName('leaflet-draw-edit-remove') as HTMLCollectionOf<HTMLElement>;
    if (deleteButton[0]) deleteButton[0].style.display = 'none';
};

export const restoreDeleteButton = () => {
    const deleteButton = document.getElementsByClassName('leaflet-draw-edit-remove') as HTMLCollectionOf<HTMLElement>;
    if (deleteButton[0]) deleteButton[0].style.display = 'block';
};
